import { useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print'

import FilterListIcon from '@mui/icons-material/FilterList'
import { Button, IconButton, Stack } from '@mui/material'
import { DataCard } from '@/components/card'
import { FiltersDrawer, StatisticsPanel } from '@/components/HistoricalStatistics'
import { TitleSetter } from '@/components/Title'

import '@/components/HistoricalStatistics/printStyles.css'

const TITLE = 'Historical Statistics'

export const HistoricalStatisticsView = () => {
  const contentRef = useRef<HTMLDivElement>(null)

  const print = useReactToPrint({
    contentRef,
    documentTitle: TITLE
  })

  const [filtersDrawerOpen, setFiltersDrawerOpen] = useState(false)

  return (
    <>
      <TitleSetter title={TITLE} />
      <DataCard
        title={TITLE}
        headerPostfixActions={
          <Stack direction="row" gap={2} alignItems="center">
            <IconButton onClick={() => setFiltersDrawerOpen((prev) => !prev)}>
              <FilterListIcon />
            </IconButton>

            <Button variant="contained" size="small" onClick={() => print()}>
              Print
            </Button>
          </Stack>
        }
      >
        <StatisticsPanel printRef={contentRef} />
      </DataCard>
      <FiltersDrawer open={filtersDrawerOpen} onClose={() => setFiltersDrawerOpen(false)} />
    </>
  )
}
